<script>
export let video;


import { Player, Video, DefaultUi } from '@vime/svelte';

</script>


<style>

/*.video-player {
	
}
*/
</style>


<Player
	theme="dark"
	style="--vm-player-theme: #cccccc;"
>
	<Video
		crossOrigin
		poster=""
	>
		<source 
			data-src="{video.video_url}" 
			type="video/mp4"
		/>
		<track 
			default 
			kind="subtitles" 
			src="https://media.vimejs.com/subs/english.vtt" 
			srclang="en" 
			label="English" 
		/>
  	</Video>
  
	<DefaultUi />
</Player>
